const type1 = [
  {
    value: `קוד פלוס שלב 3-1 (מס' תוכנית: 16955)  – מומלץ!`,
  },
  {
    value: `למידה מותאמת אישית במתמטיקה – הזדמנויות ואתגרים (מס' תוכנית: 16958) – מומלץ!`,
  },
  {
    value: `חדשנות פדגוגית בהוראת המדעים בגילים הצעירים (מס' תוכנית: 15095) - מומלץ!`,
  },
  {
    value: `הוראת מתמטיקה בכיתה הטרוגנית (מס' תוכנית: 16965)`,
  },
  {
    value: `הערכה ככלי לשיפור הוראת מתמטיקה (מס' תוכנית: 15636)`,
  },
  {
    value: `הבנת הנקרא של הטקסט העיוני בסביבה דיגיטלית (מס' תוכנית: 14718)`,
  },
  {
    value: `סדנה דיגיטלית לכתיבת סיפור (מס' תוכנית: 14728)`,
  },
  {
    value: `שיפור ההבעה בכתב ובע"פ דרך השימוש בדרמה (מס' תוכנית: 14870)`,
  },
  {
    value: `פיתוח מיומנויות ה-SEL של צוותי ההוראה והתלמידים, בהתאמה לצרכים הייחודיים של כל ביה"ס (מס' תוכנית: 15412)`,
  },
  {
    value: `לימוד משותף בשפות: אנגלית, עברית/ערבית (מס' תוכנית: 15112)`,
  },
  {
    value: `לימוד משותף: שכנות טובה (מס' תוכנית: 19071)`,
  },
  {
    value: `סביבה ביחד: לימוד משותף בנושא אקלים (מס' תוכנית: 15108)`,
  },
  {
    value: `תוכנית "דור" בר/בת מצווה (תוכנית מס': 19526)`,
  },
  {
    value: `בתי ספר מאמצים T.E.A.M מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
];

const type2 = [
  {
    value: `TeamUp – עוזרי הוראה אונליין (מס' תוכנית: 19506) – מומלץ!`,
  },
  {
    value: `קוד איקס בונים אפליקציות ע"י בינה מלאכותית (מס' תוכנית: 19418) – מומלץ!`,
  },
  {
    value: `הוראת עברית (לשון, הבנה והבעה) בסביבות דיגיטליות לחט"ב (מס' תוכנית: 14500) - מומלץ!`,
  },
  {
    value: `הוראת עברית (לשון, הבנה והבעה) בסביבות דיגיטליות לחט"ע (מס' תוכנית: 14515)`,
  },
  {
    value: `KNOW-HOW - בתי ספר מקדמים פעלנות ולמידה עצמאית (מס' תוכנית: 14638)`,
  },
  {
    value: `לומד עצמאי - בתי ספר מקדמים פעלנות ולמידה עצמאית (מס' תוכנית: 14656)`,
  },
  {
    value: `פיתוח מיומנויות ה-SEL  של צוותי ההוראה והתלמידים, בהתאמה לצרכים הייחודיים של כל ביה"ס (מס' תוכנית: 15412)`,
  },
  {
    value: `לימוד משותף בשפות: אנגלית, עברית/ערבית (מס' תוכנית: 15112)`,
  },
  {
    value: `לימוד משותף: שכנות טובה (מס' תוכנית: 19071)`,
  },
  {
    value: `סביבה ביחד: לימוד משותף בנושא אקלים (מס' תוכנית: 15108)`,
  },
  {
    value: `תכנית "דור" בר/בת מצווה (תוכנית מס': 19526)`,
  },
  {
    value: `T.E.A.M  בתי ספר מאמצים מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
  {
    value: `HMP - יזמות חינוכית טכנולוגית (תוכנית מס': 14672)`,
  },
];

const type3 = [
  {
    value: `למידה מותאמת אישית במתמטיקה – הזדמנויות ואתגרים (מס' תוכנית: 16958) – מומלץ!`,
  },
  {
    value: `הוראת מתמטיקה בכיתה הטרוגנית (מס' תוכנית: 16965)`,
  },
  {
    value: `הערכה ככלי לשיפור הוראת מתמטיקה (מס' תוכנית: 15636)`,
  },
  {
    value: `שיפור ההבעה בכתב ובע"פ דרך השימוש בדרמה (מס' תוכנית: 14870)`,
  },
  {
    value: `לימוד משותף בשפות: אנגלית, עברית/ערבית (מס' תוכנית: 15112)`,
  },
  {
    value: `לימוד משותף: שכנות טובה (מס' תוכנית: 19071)`,
  },
  {
    value: `סביבה ביחד: לימוד משותף בנושא אקלים (מס' תוכנית: 15108)`,
  },
  {
    value: `T.E.A.M  בתי ספר מאמצים מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
];

const type4 = [
  {
    value: `Top-Online (טופ-אונליין) (תוכנית מס': 15117) – מומלץ!`,
  },
  {
    value: `עבריתנא - חונכות אונליין בעברית (מס' תוכנית: 13459) - מומלץ!`,
  },
  {
    value: `TeamUp - עוזרי הוראה אונליין – (מס' תוכנית: 19506) - מומלץ!`,
  },
  {
    value: `KNOW-HOW (בתי ספר מקדמים פעלנות ולמידה עצמאית) (מס' תוכנית: 14638)`,
  },
  {
    value: `לומד עצמאי (בתי ספר מקדמים פעלנות ולמידה עצמאית) (מס' תוכנית: 14656)`,
  },
  {
    value: `HMP (יזמות חינוכית טכנולוגית) (מס' תוכנית: 14672)`,
  },
  {
    value: `نقرأ، نعرف فنعبّر (לקרוא, לדעת ולהביע)  (מס' תוכנית: 14525)`,
  },
  {
    value: `לימוד משותף בשפות: אנגלית, עברית/ערבית (מס' תוכנית: 15112)`,
  },
  {
    value: `לימוד משותף: שכנות טובה (מס' תוכנית: 19071)`,
  },
  {
    value: `סביבה ביחד: לימוד משותף בנושא אקלים (מס' תוכנית: 15108)`,
  },
  {
    value: `T.E.A.M  בתי ספר מאמצים מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
];

const type5 = [
  {
    value: `קוד פלוס שלב 3-1 (מס' תוכנית: 16955)`,
  },
  {
    value: `פלתורה – חשיבה חישובית (תוכנית מס' 11773)`,
  },
  {
    value: `פיתוח מיומנויות ה-SEL של צוותי ההוראה והתלמידים, בהתאמה לצרכים הייחודיים של כל ביה"ס (מס' תוכנית: 15412)`,
  },
  {
    value: `בתי ספר מאמצים T.E.A.M מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
];

const type6 = [
  {
    value: `TeamUP – עוזרי הוראה אונליין (מס' תוכנית: 19506)`,
  },
  {
    value: `קוד איקס בונים אפליקציות ע"י בינה מלאכותית (מס' תוכנית: 19418)`,
  },
  {
    value: `הוראת עברית (לשון, הבנה והבעה) בסביבות דיגיטליות לחט"ב (מס' תוכנית: 14500)`,
  },
  {
    value: `פיתוח מיומנויות ה-SEL של צוותי ההוראה והתלמידים, בהתאמה לצרכים הייחודיים של כל ביה"ס (מס' תוכנית: 15412)`,
  },
  {
    value: `HMP -יזמות חינוכית טכנולוגית (מס' תוכנית 14672)`,
  },
  {
    value: `T.E.A.M- טכנולוגיות חינוכיות (מס' תוכנית 14616)`,
  },
];

const type7 = [
  {
    value: `Top-Online (טופ-אונליין) (תוכנית מס': 15117)`,
  },
  {
    value: `עבריתנא - חונכות אונליין בעברית (מס' תוכנית: 13459)`,
  },
  {
    value: `TeamUp - עוזרי הוראה אונליין – (מס' תוכנית: 19506)`,
  },
  {
    value: `לומד עצמאי (בתי ספר מקדמים פעלנות ולמידה עצמאית) (מס' תוכנית: 14656)`,
  },
  {
    value: `HMP (יזמות חינוכית טכנולוגית) (מס' תוכנית: 14672)`,
  },
  {
    value: `T.E.A.M בתי ספר מאמצים מוקדמים של טכנולוגיות חינוכיות (תוכנית מס': 14616)`,
  },
];

export const courseType = {
  type1,
  type2,
  type3,
  type4,
  type5,
  type6,
  type7
};
